module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "TITLE"
  }, [_vm._v("Becoming the Gospel")]), _vm._v(" "), _c('p', {
    staticClass: "SUBTITLE"
  }, [_vm._v("Paul, Participation, and Mission")]), _vm._v(" "), _c('p', {
    staticClass: "AUTHOR"
  }, [_vm._v("Michael J. Gorman")]), _vm._v(" "), _c('p', {
    staticClass: "AUTHOR"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("William B. Eerdmans Publishing Company"), _c('br'), _vm._v("Grand Rapids, Michigan / Cambridge, U.K.")])]), _vm._v(" "), _c('p', {
    staticClass: "COPYRIGHT"
  }, [_vm._v("© 2015 Michael J. Gorman"), _c('br'), _vm._v("All rights reserved"), _c('br'), _c('br'), _vm._v("Wm. B. Eerdmans Publishing Co."), _c('br'), _vm._v("2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /"), _c('br'), _vm._v("P.O. Box 163, Cambridge CB3 9PU U.K."), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.eerdmans.com",
      "target": "_blank"
    }
  }, [_vm._v("www.eerdmans.com")]), _c('br'), _c('br'), _vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "LIBRARY"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Gorman, Michael J., 1955-"), _c('br'), _vm._v("Becoming the gospel: Paul, participation, and mission / Michael J. Gorman."), _c('br'), _vm._v("\tpages   cm.   — (The Gospel and our culture series)"), _c('br'), _vm._v("Includes bibliographical references."), _c('br'), _vm._v("ISBN 978-0-8028-6884-8 (pbk.: alk. paper)"), _c('br'), _vm._v("eISBN 978-1-4674-4298-5 (ePub)"), _c('br'), _vm._v("eISBN 978-1-4674-4258-9 (Kindle)"), _c('br'), _vm._v("1. Bible. Epistles of Paul — Criticism, interpretation, etc."), _c('br'), _vm._v("2. Missions — Biblical teaching."), _c('br'), _vm._v("3. Mission of the church — Biblical teaching."), _c('br'), _vm._v("I. Title."), _c('br'), _c('br'), _vm._v("BS2650.52.G67 2015"), _c('br'), _vm._v("227"), _c('span', {
    staticClass: "symbol"
  }, [_vm._v("′")]), _vm._v(".06 — dc23"), _c('br'), _vm._v("\t\t2014043606")]), _vm._v(" "), _c('p', {
    staticClass: "NRSV"
  }, [_vm._v("All Scripture quotations, unless otherwise noted, are from the New Revised Standard Version, copyright 1989, Division of Christian Education of the National Council of Churches of Christ in the United States of America. Used by permission. All rights reserved.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42f65156","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gorman_Becoming_the_Gospel_text_CC1.vue
// module id = 60
// module chunks = 0